import {observer} from "mobx-react";
import {FieldSelect} from "../../ui";
import {FieldInput} from "@kroschke/react-ui";
import {countryStore} from "../../../store";
import "./SlsWarehouseAddressForm.scss"

export interface SlsWarehouseAddressFormData {
    city: string
    country: string
    houseNumber: string
    postCode: string
    street: string
}

interface SlsWarehouseAddressFormProps {
    disabled: boolean
    data: SlsWarehouseAddressFormData
    position: number
    onBlur: () => any
    validationFor: (p: string) => string | undefined
    onChange: (value: SlsWarehouseAddressFormData) => any
    onDelete: (position: number) => any
}


const SlsWarehouseAddressForm = observer(function SlsWarehouseAddressForm({
                                                                              disabled,
                                                                              data,
                                                                              position,
                                                                              validationFor,
                                                                              onBlur,
                                                                              onChange,
                                                                              onDelete,
                                                                          }: SlsWarehouseAddressFormProps) {

    const {
        city,
        country,
        houseNumber,
        postCode,
        street,
    } = data

    const validationKeyPrefix = `internalAddresses[${position}]`

    return <>
        <div className="card">
            <header className="card-header has-shadow">
                <p className="card-header-title">{position + 1}. Adresse</p>
                <button
                    className={"card-header-icon has-text-danger"} aria-label="delete"
                    type={"button"}
                    disabled={disabled}
                    onClick={() => onDelete(position)}>
                    <span className="material-symbols-outlined">delete</span>
                </button>
            </header>
            <div className="card-content">
                <div className="content">
                    <div className={"columns"}>
                        <div className={'column is-one-third'}>
                            <FieldInput
                                disabled={disabled}
                                required={true}
                                help={validationFor(validationKeyPrefix + '.street')}
                                invalid={Boolean(validationFor(validationKeyPrefix + '.street'))}
                                value={street}
                                onBlur={() => onBlur()}
                                onChange={val => onChange({
                                    ...data,
                                    street: val
                                })}
                                label={"Straße"}
                            />
                        </div>
                        <div className={'column is-one-third'}>
                            <FieldInput
                                disabled={disabled}
                                help={validationFor(validationKeyPrefix + '.houseNumber')}
                                invalid={Boolean(validationFor(validationKeyPrefix + '.houseNumber'))}
                                value={houseNumber}
                                onBlur={() => onBlur()}
                                onChange={val =>
                                    onChange({
                                        ...data,
                                        houseNumber: val
                                    })
                                }
                                label={"Hausnummer"}
                            />
                        </div>
                        <div className={'column is-one-third'}></div>
                    </div>
                    <div className={"columns"}>
                        <div className={'column is-one-third'}>
                            <FieldInput
                                disabled={disabled}
                                required={true}
                                help={validationFor(validationKeyPrefix + '.postCode')}
                                invalid={Boolean(validationFor(validationKeyPrefix + '.postCode'))}
                                value={postCode}
                                onBlur={() => onBlur()}
                                onChange={val => onChange({
                                    ...data,
                                    postCode: val
                                })}
                                label={"PLZ"}
                            />
                        </div>
                        <div className={'column is-one-third'}>
                            <FieldInput
                                disabled={disabled}
                                required={true}
                                help={validationFor(validationKeyPrefix + '.city')}
                                invalid={Boolean(validationFor(validationKeyPrefix + '.city'))}
                                value={city}
                                onBlur={() => onBlur()}
                                onChange={val => onChange({
                                    ...data,
                                    city: val
                                })}
                                label={"Ort"}
                            />
                        </div>
                        <div className={'column is-one-third'}>
                            <FieldSelect
                                disabled={disabled}
                                label={"Land"}
                                help={validationFor(validationKeyPrefix + '.country')}
                                invalid={Boolean(validationFor(validationKeyPrefix + '.country'))}
                                options={countryStore.options}
                                value={country}
                                onBlur={() => onBlur()}
                                onChange={val => {
                                    onChange({
                                        ...data,
                                        country: val
                                    })
                                }}
                                required={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
})

export {
    SlsWarehouseAddressForm
}
